import { useQuery } from "@tanstack/react-query";
import { get } from "lodash-es";
import type { CatalogElement } from "../../../../models/CatalogElement";
import { getCatalogElements } from "../../../../repositories/CatalogElementRepository";

export const useCatalogElementsQuery = () => {
  return useQuery<CatalogElement[], Error>({
    queryKey: ["lab-catalog-elements"],
    queryFn: async ({ signal }) => {
      const resp = await getCatalogElements(signal);
      if (!resp.ok)
        throw new Error(resp.message ?? "Failed to load catalog elements");
      return get(resp, "data.tables[0].rows", []);
    },
  });
};
